import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Bouton d'impression contextuel à afficher uniquement sur les pages où
 * l'impression a du sens (fiches de référence, mémos à emporter, etc.).
 *
 * Usage :
 *   <PrintButton label="Imprimer le barème" />
 *   <PrintButton variant="ghost" size="sm" />
 */
export const PrintButton = ({
  label = 'Imprimer',
  variant = 'outline',
  size = 'sm',
  className = '',
  testid = 'page-print-btn',
  ...rest
}) => (
  <Button
    variant={variant}
    size={size}
    onClick={() => window.print()}
    data-testid={testid}
    className={`gap-1.5 rounded-full ${className}`}
    {...rest}
  >
    <Printer className="w-4 h-4" />
    <span className="hidden sm:inline">{label}</span>
  </Button>
);
